const tableOptions = [
  {
    name: "Valor",
    field: "value",
    type: "float",
  },
  {
    name: "Status",
    field: "status__name",
    type: "select",
  },
  {
    name: "Atribuído",
    field: "user_associated_id__first_name",
    type: "string",
  },
];

const detailsOptions = [
  {
    name: "Requerente",
    field: "titular",
    type: "string",
  },
  {
    name: "CPF / CNPJ",
    field: "titular_document",
    type: "string",
  },
  {
    name: "Endereço",
    field: "address",
    type: "string",
  },
  {
    name: "Procedimento",
    field: "procedure",
    type: "string",
  },
  {
    name: "Natureza",
    field: "nature",
    type: "string",
  },
  {
    name: "Data Inicial",
    field: "trf_protocol_date",
    type: "date",
  },
  {
    name: "Ano do Orçamento",
    field: "proposal_year",
    type: "string",
  },
  {
    name: "Ano de Liquidação",
    field: "account_settlement_date",
    type: "year",
  },
  {
    name: "Requerido",
    field: "defendant",
    type: "string",
  },
  {
    name: "Advogado",
    field: "lawyer",
    type: "string",
  },
  {
    name: "Juízo de Origem",
    field: "originating_court",
    type: "string",
  },
  {
    name: "Processos originários",
    field: "original_processes",
    type: "string",
  },
  {
    name: "Número do processo",
    field: "process_number",
    type: "string",
  },
  {
    name: "Status do Processamento",
    field: "process_status",
    type: "string",
  },
  {
    name: "Data da distribuição",
    field: "distribution_date",
    type: "date",
  },
  {
    name: "Classe Judicial",
    field: "judicial_class",
    type: "string",
  },
  {
    name: "Assunto",
    field: "subject",
    type: "string",
  },
  {
    name: "Jurisdição",
    field: "jurisdiction",
    type: "string",
  },
  {
    name: "Orgão Julgador",
    field: "judging_body",
    type: "string",
  },
  {
    name: "Participantes",
    field: "participants",
    type: "string",
  },
];

const allFilterOptions = tableOptions.concat(detailsOptions).sort((a, b) => {
  if (a.name.toUpperCase() === b.name.toUpperCase()) return 0;
  if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
  return -1;
});
export default allFilterOptions;
